function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { ErrorMessage, Field } from 'formik';
import PropTypes from 'prop-types';
import React, { memo } from 'react';
import ErrorText from '../ErrorText';
import Flex from '../Flex';
import Checkbox from './Checkbox';
import Description from './Description';
import FormGroup from './FormGroup';
import Label from './Label';
const CheckboxFormGroup = /*#__PURE__*/memo(_ref => {
  let {
    name,
    label,
    description,
    type = 'text',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Field, _extends({
    name: name,
    component: Checkbox,
    type: type
  }, props, {
    flex: "0 0 auto"
  })), !!label && /*#__PURE__*/React.createElement(Label, {
    display: "inline",
    fontWeight: "normal",
    fontSize: 1,
    flex: "1 1 0"
  }, label)), !!description && /*#__PURE__*/React.createElement(Description, null, description), /*#__PURE__*/React.createElement(ErrorMessage, {
    name: name,
    component: ErrorText
  }));
});
CheckboxFormGroup.propTypes = {
  description: PropTypes.string,
  label: PropTypes.any,
  name: PropTypes.string.isRequired,
  type: PropTypes.string
};
CheckboxFormGroup.displayName = 'CheckboxFormGroup';
export default CheckboxFormGroup;